import React, {Fragment} from 'react';
import Header from '../Header';

const Page = ({
  component: Component,
  header: HeaderComponent,
  customHeader,
  ...props
}) => (
  <Fragment>
    {!customHeader && (
      <Header>
        <HeaderComponent {...props} />
      </Header>
    )}

    <Component {...props} />
  </Fragment>
);

export {Page};
